<div class="relative">
  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    style="width: 100%; height: 500px"
    [columnDefs]="columnDefs"
    (rowDoubleClicked)="onRowDoubleClicked($event)"
    [rowData]="salesOrder?.clientInvoices"
  ></ag-grid-angular>
</div>
